// extracted by css-extract-rspack-plugin
export default {"tooltip":"tooltip-bFauPZ"};